import React from 'react';
import { useSelector } from 'react-redux';

import NavigationItem from './NavigationItem';
import NavigationOverlay from './NavigationOverlay';

const Navigation = () => {
    const contentLinks = useSelector((state) => state.navigation.contentLinks);
    const overlayState = useSelector((state) => state.overlay.status);
    return (
        <>
            {overlayState && <NavigationOverlay />}
            <NavigationItem links={contentLinks} level={0} />
        </>
    );
};

export default Navigation;
